import React from 'react';
import SettingsIcon from '@/assets/icons/settings.svg?react';
import LogoutIcon from '@/assets/icons/logout.svg?react';

import { useNewAuth } from '@/providers/AuthProvider/NewAuthProvider.hooks';
import { IconWithHover } from '@/layouts/MainLayout/components/Sidebar/components/IconWithHover/IconWithHover';
import { StyledBottomNavWrapper, StyledSettingsPanelWrapper } from './BottomNavigation.styled';
import { ERoutes } from '@/types/routes';

export const BottomNavigation = () => {
  const { logOut } = useNewAuth();

  return (
    <StyledBottomNavWrapper>
      <StyledSettingsPanelWrapper>
        <IconWithHover
          variant="link"
          href={ERoutes.SETTINGS}
          Icon={SettingsIcon}
          tooltip="Settings"
          tourDataId="settings-navigation-button"
        />
      </StyledSettingsPanelWrapper>

      <IconWithHover variant="button" onClick={() => logOut()} Icon={LogoutIcon} tooltip="Logout" />
    </StyledBottomNavWrapper>
  );
};
